import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/OrdenVenta/ordenventa';
import ListaOrdenes from './ListaOrdenesVenta';

const mstp = state => {
    return {...state.ordenventa, permisos: state.login.me.permisos}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(ListaOrdenes)
